module.exports = "/assets/data/5c2705eed12053cebd1fe01fd97ca5d6-CB21.data.json";